// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiGlobalApproval } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";

interface DomainApprovalParams {
  country: string;
  nid: string;
}

interface DomainApprovalResponse {
  data?: unknown;
  message?: string;
  success: boolean;
}

export const domainApproval = apiGlobalApproval.injectEndpoints({
  endpoints: (builder) => ({
    getDomainApproval: builder.query<
      DomainApprovalResponse,
      DomainApprovalParams
    >({
      query: ({ country, nid }: DomainApprovalParams) => {
        return `/domain_approval?country=${country}&nid=${nid}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "getDomainApproval",
        };
        return modelError;
      },
      transformResponse: (response: DomainApprovalResponse) => {
        return response;
      },
    }),
  }),
});

export const { useGetDomainApprovalQuery, useLazyGetDomainApprovalQuery } =
  domainApproval;
